import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { catalogRatiosHistoryStatusCountsGql } from '../catalogRatiosHistoryQueries';

interface IUseHistoryCountsProps {
    catalogUniqueId: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
}

const requestId = 'catalogRatioHistoryStatusCounts';

export const useHistoryCounts = ({ catalogUniqueId, startDate, endDate }: IUseHistoryCountsProps) => {
    const variables = useMemo(() => {
        if (catalogUniqueId && startDate && endDate) {
            return {
                catalogUniqueId,
                startDate,
                endDate,
            };
        }

        return undefined;
    }, [catalogUniqueId, endDate, startDate]);

    const [data] = useRequest({
        requestId,
        query: catalogRatiosHistoryStatusCountsGql,
        variables,
        withEffect: !!variables,
    });

    const [resetData] = useResetStoreData({
        requestId,
    });

    useEffect(() => {
        if (!startDate) {
            resetData(undefined);
        }
    }, [endDate, resetData, startDate]);

    const countsObj = useMemo(
        () => ({
            deletedCostsCount: data?.catalogRatioHistoryStatusCounts?.data?.deletedCount ?? 0,
            updatedCostsCount: data?.catalogRatioHistoryStatusCounts?.data?.updatedCount ?? 0,
            createdCostsCount: data?.catalogRatioHistoryStatusCounts?.data?.newCount ?? 0,
        }),
        [
            data?.catalogRatioHistoryStatusCounts?.data?.deletedCount,
            data?.catalogRatioHistoryStatusCounts?.data?.updatedCount,
            data?.catalogRatioHistoryStatusCounts?.data?.newCount,
        ],
    );

    return countsObj;
};
